// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPrescriber {
    static getAttributeTypeMap() {
        return MedicalBiPrescriber.attributeTypeMap;
    }
}
MedicalBiPrescriber.discriminator = undefined;
MedicalBiPrescriber.additionalProperties = false;
MedicalBiPrescriber.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "MedicalBiAddress"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPrescriber.js.map